import { Controller } from "@hotwired/stimulus"

export default class FilterResetController extends Controller {
  static targets = ["resetable", "checkbox"]
  static outlets = ["select"]

  declare resetableTargets: HTMLSelectElement[]
  declare checkboxTargets: HTMLInputElement[]
  declare selectOutlet: { clearValue: (silent?: boolean) => void }
  declare hasSelectOutlet: boolean

  reset(): void {
    if (this.hasSelectOutlet) {
      this.selectOutlet.clearValue(false)
    }
    this.resetableTargets.forEach((el) => { el.value = "" })
    this.checkboxTargets.forEach((el) => { el.checked = false })
  }
}
